module.exports = __webpack_public_path__ + "img/banner-2.c52b64a2.jpg";